import React from "react";
import style from "./index.module.scss";
import { getDomTop } from "@/common/utils/index.js";

class Exhibition extends React.Component {
  
  state = {
    ex1State: false,
    ex2State: false,
    ex3State: false,
    endState: false
  };

  exhibitonRef = React.createRef();
  ex1 = React.createRef();
  ex2 = React.createRef();
  ex3 = React.createRef();

  componentDidMount() {
    window.addEventListener("resize", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleScroll);
  }

  handleScroll = () => {
    const info = this.props.pageInfo;
    this.checkEx1(info);
    this.checkEx2(info);
    this.checkEx3(info);
  };

  checkEx1 = () => {
    this.setState({
      ex1State: this.props.open
    });
  };
  
  checkEx2 = (info) => {
    const activeTop = info.clientHeight * 1.5;
    const ex2Top = getDomTop(this.ex2.current);
    this.setState({
      ex2State: info.scrollTop > activeTop && ex2Top < info.pageBottom
    });
  };

  checkEx3 = (info) => {
    const activeTop = info.clientHeight * 1.8;
    const endTop = info.clientHeight * 2.2;
    const ex3Top = getDomTop(this.ex3.current);
    this.setState({
      ex3State: info.scrollTop > activeTop && ex3Top < info.pageBottom
    });
    const exTop = getDomTop(this.exhibitonRef.current) + this.exhibitonRef.current.clientHeight;
    // console.log(info.scrollTop > endTop, info.scrollTop > exTop);
    if (info.scrollTop > endTop && info.pageBottom > exTop) {
      this.props.changeToBg();
      this.setState({endState: true});
    } else {
      this.props.backToBg();
      this.setState({endState: false});
    }
  };


  render() {
    return (
      <section>
        <div className={`${style.exhibition_box} exhibition_box`} ref={this.exhibitonRef}>
          <div className={style.exhibition1} ref={this.ex1}
            style={{transform: `translateY(${this.state.ex2State ? -20 : 0}vh)`, opacity: this.state.ex2State ? 0.4 : 1}}>
            <div className={`${style.exhibition1_left} ${this.state.ex1State ? "active" : ""}`}
              style={{transform: `translateY(${this.state.ex1State ? -20 : 0}vh)`, opacity: this.state.ex1State ? 1 : 0}}>
              <div className={`polygon ${style.polygon1}`}></div>
              <div className={`polygon ${style.polygon2}`}></div>
              <div className={`polygon ${style.polygon3}`}></div>
              <div className={style.man1}></div>
            </div>
            <div className={`${style.exhibition1_right}`}
              style={{transform: `translateY(${this.state.ex1State ? -20 : 0}vh)`, opacity: this.state.ex1State ? 1 : 0.4}}>
              <p className={`${style.title} ${style.title1}`}>{ this.props.langState.homeData.exhibition1.title }</p>
              <p className={style.desc}>{ this.props.langState.homeData.exhibition1.desc }</p>
            </div>
          </div>
          <div className={style.exhibition2} ref={this.ex2}
            style={{transform: `translateY(${this.state.ex3State ? -20 : 0}vh)`, opacity: this.state.ex3State ? 0.4 : 1}}>
            <div className={`${style.exhibition2_left}`}
              style={{transform: `translateY(${this.state.ex2State ? -20 : 0}vh)`, opacity: this.state.ex2State ? 1 : 0.4}}>
              <p className={`${style.title} ${style.title2}`}>{ this.props.langState.homeData.exhibition2.title }</p>
              <p className={style.desc}>{ this.props.langState.homeData.exhibition2.desc }</p>
            </div>
            <div className={`${style.exhibition2_right} ${this.state.ex2State ? "active" : ""}`}
              style={{transform: `translateY(${this.state.ex2State ? -20 : 0}vh)`, opacity: this.state.ex2State ? 1 : 0}}>
              <div className={`triangle1 ${style.triangle1}`}></div>
              <div className={`triangle2 ${style.triangle2}`}></div>
              <div className={`triangle3 ${style.triangle3}`}></div>
              <div className={style.pet2}></div>
              <div className={style.man2}></div>
            </div>
          </div>
          <div className={style.exhibition3} ref={this.ex3}
            style={{transform: `translateY(${this.state.endState ? -20 : 0}vh)`, opacity: this.state.endState ? 0 : 1}}>
            <div className={`${style.exhibition3_left} ${this.state.ex3State ? "active" : ""}`}
              style={{transform: `translateY(${this.state.ex3State ? -20 : 0}vh)`, opacity: this.state.ex3State ? 1 : 0}}>
              <div className={`circular ${style.circular1}`}></div>
              <div className={`circular ${style.circular2}`}></div>
              <div className={`circular ${style.circular3}`}></div>
              <div className={style.pet3}></div>
              <div className={style.man3}></div>
            </div>
            <div className={`${style.exhibition3_right}`}
              style={{transform: `translateY(${this.state.ex3State ? -20 : 0}vh)`, opacity: this.state.ex3State ? 1 : 0.4}}>
              <p className={`${style.title} ${style.title3}`}>{ this.props.langState.homeData.exhibition3.title }</p>
              <p className={style.desc}>{ this.props.langState.homeData.exhibition3.desc }</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Exhibition;
